import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { FDBodyText } from '@facet-wealth/design';

const useStyles = buildUseStyles('Amount', (theme) => ({
  root: {
    '& .FD-MuiTypography-root': {
      wordBreak: 'keep-all',
    },
  },
  strikethrough: {
    '& .FD-MuiTypography-root': {
      textDecoration: 'line-through',
      color: theme.palette.action.disabled,
    },
  },
}));

export function Amount({ value, strikethrough }) {
  const classes = useStyles();
  if (!value) return null;
  return (
    <div className={classNames(classes.root, { [classes.strikethrough]: strikethrough })}>
      <FDBodyText size="lg" value={value} />
    </div>
  );
}

Amount.defaultProps = {
  value: null,
  strikethrough: false,
};

Amount.propTypes = {
  value: PropTypes.string,
  strikethrough: PropTypes.bool,
};
